import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

// layouts
import { AdminComponent } from "../../layouts/admin/admin.component";

// admin views
import { DashboardComponent } from "./dashboard/dashboard.component";
import { MapsComponent } from "./maps/maps.component";
import { TablesComponent } from "./tables/tables.component";
import { DoctorInfoComponent } from "./doctors/doctor-info/doctor-info.component";
import { UserWalletComponent } from "./user-wallet/user-wallet.component";
import { MessageComponent } from "./message/message.component";
import { ChatComponent } from "./chat/chat.component";
import { PatientProfileComponent } from "./patient-profile/patient-profile.component";
import { DoctorCalendarComponent } from "./doctors/doctor-calendar/doctor-calendar.component";
import { VisitsComponent } from "./visits/visits.component";
import { DoctorsComponent } from "./doctors/doctors.component";

export const AdminLayoutRoutes: Routes = [
      { path: "dashboard", component: DashboardComponent },
      { path: "tables", component: TablesComponent },
      { path: "maps", component: MapsComponent },
      { path: "wallet", component: UserWalletComponent},
      { path: "message", component: MessageComponent},
      { path: "chat", component: ChatComponent},
      { path: "patient-info/:id", component: PatientProfileComponent},
      { path: "visits", component: VisitsComponent},
      { path: "doctors", component: DoctorsComponent},
      { path: "doctor-info/:id", component: DoctorInfoComponent},
      { path: "doctor-calendar/:id", component: DoctorCalendarComponent},
      { 
        path: "category",  
        children: [{
          path: '',
          loadChildren: () => import('./category/category.module').then(m => m.CategoryModule)
        }],
      },
      { 
        path: "settings",  
        children: [{
          path: '',
          loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule)
        }],
      },
      {
        path: "users",
        // component: AdminComponent,
        children: [{
          path: '',
          loadChildren: () => import('./users/users.module').then(m => m.UsersModule)
        }],
      },
      {
        path: "content",
        // component: AdminComponent,
        children: [{
          path: '',
          loadChildren: () => import('./website-content/website-content.module').then(m => m.WebsiteContentModule)
        }],
      },
      {
        path: "financial",
        // component: AdminComponent,
        children: [{
          path: '',
          loadChildren: () => import('./financial/financial.module').then(m => m.FinancialModule)
        }],
      },

    //   { path: "", redirectTo: "dashboard", pathMatch: "full" },
];
